export default __webpack_public_path__ + "static/media/mann-solar-bg.4f1aba9a.jpeg";